import { Deps } from 'src/types/global-types';

import { depsToDepsWithCspToken } from '../utils/utils';
import { execute, Body } from '../rest/IntegrationCustomerTokenServiceV1CreateCustomerAccessTokenPost';

export function cspCustomerSignIn(body: Body, token: string, deps: Deps) {
    return execute(body, depsToDepsWithCspToken(token, deps));
}
